import React from "react";
import "./LoadingSpinner.scss";
import { useLanguage } from "../../../contexts";

export function LoadingSpinner({ text }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="loading-spinner-wrapper">
      <div className="loading-spinner__ring">
        <div /><div /><div /><div />
      </div>
      <p className="loading-spinner__text">{text || t("loading_data")}</p>
    </div>
  );
}
